module.exports = __webpack_public_path__ + "assets/img/quiz_picture@2x.b1c370ea.jpg";